import React from "react";
import {Link} from "react-router-dom";
import BuddyCard from "@unibuddy/machop/Buddies/components/BuddyCard/BuddyCard";
import buddyCardStyle from "./BuddyCard.pcss";
import s from "./BuddyListCard.pcss";
import {useMarketplaceConfig} from "../../../MarketplaceConfigProvider";

function BuddyListCard({mentor, position}) {
    const {marketplace} = useMarketplaceConfig();
    return (
        <BuddyCard>
            <BuddyCard.Split>
                <BuddyCard.Left>
                    <Link
                        className={s.avatarLink}
                        tabIndex="-1"
                        title={`${mentor.firstName}'s profile`}
                        to={`/${marketplace.slug}/buddies/profile/${
                            mentor.id
                        }?buddyPosition=${position}`}
                    >
                        <BuddyCard.Avatar mentor={mentor} />
                    </Link>
                    <BuddyCard.Name>{mentor.firstName}</BuddyCard.Name>
                </BuddyCard.Left>
                <BuddyCard.Right>
                    <BuddyCard.Logo mentor={mentor} />
                    <BuddyCard.Degree mentor={mentor} />
                </BuddyCard.Right>
            </BuddyCard.Split>

            <BuddyCard.Separator />

            <BuddyCard.Section title="About Me">{`${mentor.shortBio}...`}</BuddyCard.Section>

            <BuddyCard.ReadMore
                to={`/${marketplace.slug}/buddies/profile/${mentor.id}?buddyPosition=${position}`}
                mentor={mentor}
                className={buddyCardStyle.readMore}
            />

            <BuddyCard.CTA
                to={`/${marketplace.slug}/inbox/chatwith/${mentor.id}?buddyPosition=${position}`}
                mentor={mentor}
                className={buddyCardStyle.cta}
            />
        </BuddyCard>
    );
}

export default React.memo(BuddyListCard);
